export default __webpack_public_path__ + "static/media/BizOne.35642760.png";